import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './MaintenancePage.css';

const MaintenancePage = ({ message }) => {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="maintenance-page">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6}>
            <div className="maintenance-card">
              <div className="maintenance-logo">
                <span className="maintenance-logo-text">MrBrown</span>
              </div>
              <h1 className="maintenance-title">Bakımdayız</h1>
              <p className="maintenance-message">
                {message || 'Sistem bakımda, lütfen daha sonra tekrar deneyin.'}
              </p>
              <p className="maintenance-subtext">
                Alışveriş deneyiminizi iyileştirmek için kısa bir bakım çalışması yapıyoruz.
              </p>
              <Button
                variant="primary"
                size="lg"
                className="maintenance-button"
                onClick={handleReload}
              >
                Sayfayı Yenile
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default MaintenancePage;

